module.exports = __webpack_public_path__ + "img/main-03-map.ebd83a96.svg";